exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".voided-box[data-v-552cf17e]{border:1px dashed #666;border-radius:5px;padding:10px 20px;margin-top:30px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-552cf17e","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/franchise_component/transaction/side_receipt.vue
// module id = iKCu
// module chunks = 18 99